import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";
import { useEffect } from "react";

const RUNGS = [
  { label: "PRO", top: "8%", left: "6%", tilt: -6, size: "text-sm", delay: 0 },
  { label: "NUN", top: "22%", left: "84%", tilt: 4, size: "text-base", delay: 0.6 },
  { label: "CI", top: "58%", left: "2%", tilt: 5, size: "text-xs", delay: 1.1 },
  { label: "A", top: "74%", left: "90%", tilt: -4, size: "text-sm", delay: 1.6 },
  { label: "TION", top: "40%", left: "92%", tilt: 3, size: "text-xs", delay: 0.3 },
  { label: "RHY", top: "88%", left: "12%", tilt: -3, size: "text-sm", delay: 2 },
];

export const LadderVisual = () => {
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const rx = useSpring(mx, { stiffness: 40, damping: 20 });
  const ry = useSpring(my, { stiffness: 40, damping: 20 });
  const shiftX = useTransform(rx, [-0.5, 0.5], [-18, 18]);
  const shiftY = useTransform(ry, [-0.5, 0.5], [-18, 18]);

  useEffect(() => {
    const handleMove = (e) => {
      mx.set(e.clientX / window.innerWidth - 0.5);
      my.set(e.clientY / window.innerHeight - 0.5);
    };
    window.addEventListener("mousemove", handleMove);
    return () => window.removeEventListener("mousemove", handleMove);
  }, [mx, my]);

  return (
    <div
      className="pointer-events-none absolute inset-0 hidden overflow-hidden md:block"
      aria-hidden="true"
      data-testid="ladder-parallax-visual"
    >
      {RUNGS.map((rung, i) => (
        <motion.div
          key={rung.label}
          className="rung-float absolute"
          style={{
            top: rung.top,
            left: rung.left,
            x: shiftX,
            y: shiftY,
            "--rung-tilt": `${rung.tilt}deg`,
            animationDelay: `${rung.delay}s`,
          }}
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, delay: 0.4 + i * 0.12 }}
        >
          <div
            className={`${rung.size} font-mono-accent font-semibold uppercase tracking-[0.2em] text-sky-700/70 bg-white/70 backdrop-blur-md border border-sky-200/60 rounded-full px-4 py-2 shadow-[0_10px_30px_-10px_rgba(2,132,199,0.25)]`}
            style={{ transform: `rotate(${rung.tilt}deg)` }}
          >
            {rung.label}
          </div>
        </motion.div>
      ))}
    </div>
  );
};
